import * as React from "react"
import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area"
import { cn } from "@lib/cn"

export interface ScrollAreaProps
  extends React.ComponentPropsWithoutRef<typeof BaseScrollArea.Root> {
  viewportClassName?: string
}

export const ScrollArea = React.forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ className, viewportClassName, children, ...props }, ref) => (
    <BaseScrollArea.Root ref={ref} className={cn("relative overflow-hidden", className)} {...props}>
      <BaseScrollArea.Viewport className={cn("size-full", viewportClassName)}>
        {children}
      </BaseScrollArea.Viewport>
      <BaseScrollArea.Scrollbar
        orientation="vertical"
        className="flex w-2.5 touch-none select-none p-0.5 opacity-0 transition-opacity duration-regular hover:opacity-100 data-[hovering]:opacity-100 data-[scrolling]:opacity-100"
      >
        <BaseScrollArea.Thumb className="relative flex-1 rounded-pill bg-cloverhound-gray-400 dark:bg-cloverhound-gray-600" />
      </BaseScrollArea.Scrollbar>
      <BaseScrollArea.Scrollbar
        orientation="horizontal"
        className="flex h-2.5 touch-none select-none p-0.5 opacity-0 transition-opacity duration-regular hover:opacity-100 data-[hovering]:opacity-100 data-[scrolling]:opacity-100"
      >
        <BaseScrollArea.Thumb className="relative flex-1 rounded-pill bg-cloverhound-gray-400 dark:bg-cloverhound-gray-600" />
      </BaseScrollArea.Scrollbar>
      <BaseScrollArea.Corner />
    </BaseScrollArea.Root>
  ),
)
ScrollArea.displayName = "ScrollArea"
